// extracted by mini-css-extract-plugin
export var details = "PlaceholderDogCarouselCard-module--details--f8938";
export var dogcard = "PlaceholderDogCarouselCard-module--dogcard--6e35c";
export var dogcardwrapper = "PlaceholderDogCarouselCard-module--dogcardwrapper--5e1d4";
export var image = "PlaceholderDogCarouselCard-module--image--64922";
export var svgwrapper = "PlaceholderDogCarouselCard-module--svgwrapper--2a438";